import React, { memo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  getLocalStorage,
  handleCompressedUpload,
  isFileAllowed,
  setLocalStorage
} from '../../../../common/common';
import { pageTitles } from '../../../../common/pageTitles';
import { BannerWorker } from '../../../../components/banner';
import { Seo } from '../../../../components/seo/Seo';
import { registerChannelToDoctube } from '../../../../Store/actions/doctube.action';
import { TrackerComponent } from '../../../../TrackerFolder';
import { trackEvent } from '../../../../TrackerFolder/actions';
import { EVENT } from '../../../../TrackerFolder/constants/ActionType';
import { useTracker } from '../../../../TrackerFolder/TrackerComponent';
import BasicForm from './BasicForm';
import CoverImgSelectionForm from './CoverImgSelectionForm';
import DoctubeShareModal from './modal/DoctubeShareModal';
import ProfilePicSelectionForm from './ProfilePicSelectionForm';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useRedirect from '../../../../components/customHooks/useRedirect';
import { authenticateUser } from '../../../../Store/actions/login.action';

const StepForms = ({ nextPrev, onNextBtnClick, userName }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  console.log('location', pathName.includes('doctube_fst'), getLocalStorage('accessToken', ''));

  const [profilePicture, setProfilePicture] = useState(null);
  const [coverPicture, setCoverPicture] = useState(null);
  const [input, setInput] = useState({
    channel_name: userName ?? '',
    about: '',
    consult_link: ''
  });
  const [linkSentShow, setLinkSentShow] = useState(false);
  const [title, setTitle] = useState('');
  const pageName = pageTitles.Doctube.dashboard;
  const { trackActivityEvent } = useTracker();

  const handleClose = () => {
    setLinkSentShow(false);
    navigate('/');
  };
  const handleShow = () => setLinkSentShow(true);
  const dispatch = useDispatch();
  const { redirectTo } = useRedirect();
  const modalTextHandler = useCallback(
    (type) => {
      if (pathName.includes('doctube_fst')) {
        dispatch(
          authenticateUser(
            getLocalStorage('accessToken', ''),
            (resp) => {
              if (resp != 'error') {
                if (resp.status_code == 200) {
                  redirectTo('Doctube');
                }
              }
            },
            'doctube_fst'
          )
        );
        // alert("doctube fst")
        // redirectTo('Doctube');
      } else {
        if (type == 'modal') {
          setTitle(
            'We are sorry to see you go! Please complete your DocTube™ page to get access to the revolution changing the face of Indian healthcare. Millions of patients are waiting to hear from you.'
          );
          trackActivityEvent(EVENT, trackEvent('DOCTUBE_SHAREPAGE_SKIPPED'));
        } else {
          setTitle(
            'Congratulations! Welcome to the revolution changing the face of Indian healthcare. Click on the message received on your phone to start uploading videos for the millions of patients waiting to hear from you.'
          );
          trackActivityEvent(EVENT, trackEvent('DOCTUBE_SHAREPAGE_CHANNEL_REGISTER'));
        }
        handleShow();
      }
    },
    [title]
  );
  const handleInput = useCallback(
    (e) =>
      setInput((prev) => {
        let { name, value } = e.target;
        return { ...prev, [name]: value };
      }),
    [input]
  );
  const uploadProfilePicture = useCallback(
    (e) => {
      let image = e.target.files[0];
      if (image) {
        if (isFileAllowed(image, 4)) {
          handleCompressedUpload(image, (compressed) => {
            setProfilePicture(compressed);
          });
        }
      }
    },
    [profilePicture]
  );
  const profileAvatorSelect = useCallback(
    (selectedAvator) => {
      setProfilePicture(selectedAvator);
    },
    [profilePicture]
  );
  const uploadCoverPicture = useCallback(
    (e) => {
      let image = e.target.files[0];
      if (image) {
        if (isFileAllowed(image, 4)) {
          handleCompressedUpload(image, (compressed) => {
            setCoverPicture(compressed);
          });
        }
      }
    },
    [coverPicture]
  );
  const defaultCoverSelect = useCallback(
    (selectedDefault) => {
      setCoverPicture(selectedDefault);
    },
    [coverPicture]
  );
  const registerChannel = () => {
    let { channel_name, about, consult_link } = input;
    let userPostObj = {
      channel_name,
      avatar: typeof profilePicture == 'object' ? profilePicture : '',
      default_avatar: typeof profilePicture == 'string' ? profilePicture : '',
      about,
      consult_link: consult_link || '',
      cover: typeof coverPicture == 'object' ? coverPicture : '',
      default_cover: typeof coverPicture == 'string' ? coverPicture : '',
      platform_id: getLocalStorage('user', false)
        ? getLocalStorage('user', '{}')?.user_master_id
        : 0,
      platform_type: 'user_master'
    };
    // toast.success('done');
    //
    console.log('share page', userPostObj);
    dispatch(
      registerChannelToDoctube(userPostObj, (res) => {
        console.log('REGISTER CHANNEL RESPONSE', res);
        if (res.status_code != 200) {
          toast.error(
            res?.message ??
              'Something went wrong. Please fill all the mandatory fields and try again'
          );
          return;
        }
        if (res.status_code == 200) {
          modalTextHandler('submit');
          setLocalStorage('doctube_access_token', res?.data?.token);
          setLocalStorage('doctube_refresh_token', res?.data?.refresh_token);

          // toast.success('done');
        }
      })
    );
  };
  return (
    <>
      {/* <TrackerComponent page_name={pageName} module_page="doctube_details" /> */}
      <Seo title={`CLIRNET - ${pageName}`} url={window.location.href} />
      {nextPrev == 1 ? (
        <BasicForm
          onNextBtnClick={onNextBtnClick}
          input={input}
          handleInput={handleInput}
          modalTextHandler={modalTextHandler}
        />
      ) : null}
      {nextPrev == 2 ? (
        <ProfilePicSelectionForm
          onNextBtnClick={onNextBtnClick}
          onUpload={uploadProfilePicture}
          onAvatorSelect={profileAvatorSelect}
          selectedProfilePicture={profilePicture}
        />
      ) : null}
      {nextPrev == 3 ? (
        <CoverImgSelectionForm
          onNextBtnClick={onNextBtnClick}
          onUpload={uploadCoverPicture}
          onDefaultSelect={defaultCoverSelect}
          selectedCoverPicture={coverPicture}
          registerChannel={registerChannel}
        />
      ) : null}
      <DoctubeShareModal handleClose={handleClose} linkSentShow={linkSentShow} title={title} />
    </>
  );
};

export default memo(StepForms);
